import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import { OTrackVue } from '@oplus/obus-track-vue'
// import { TrackConfig } from '@core/TrackConstants'
import { i18n } from './i18n'

// 引入路由cookie检查
import '@/router/BeforeRoute'
// 引入乾坤
import '@/qiankun'
// 引入全局错误处理
import '@/core/GlobalErrorHandler'
// 引入性能监控
// import '@/Observation'

import './components/styles/global.styl'
import './components/styles/platformAdaptive.styl'

const app = createApp(App)

// OTrackVue.install(app, TrackConfig)

app.use(i18n)
app.use(router)
app.mount('#app')
